import React from "react";

import styles from "./PlayerList.module.scss";
import { INTERNATIONAL_LEAGUE_MATCHES } from "@constants/constants";
import { encodeToBase64 } from "@utils/encodeHelper";
import { useRouter } from "next/navigation";

import ForeignPlayer from "@public/widget/svg/foreign-player.svg";
import Bowler from "@public/widget/svg/bowler.svg";
import WicketKeeper from "@public/widget/svg/wicket-keeper.svg";
import AllRounder from "@public/widget/svg/all-rounder.svg";
import Batsman from "@public/widget/svg/batsman.svg";
const skillSvgMapping = {
    sport_player_roles_prefix_2: Bowler,
    sport_player_roles_prefix_4: WicketKeeper,
    sport_player_roles_prefix_3: AllRounder,
    sport_player_roles_prefix_1: Batsman,
};

const skillStringMapping = {
    sport_player_roles_prefix_2: "BOWL",
    sport_player_roles_prefix_4: "WK",
    sport_player_roles_prefix_3: "ALL R",
    sport_player_roles_prefix_1: "BAT",
};
export interface Player {
    id: number;
    name: string;
    isCaptain?: boolean;
    battingStyle: string;
    role: string;
    countryCode: string;
    countryFlag: string; // URL to the flag
}

interface PlayerListProps {
    players: any;
    seriesName: string;
}

const PlayerList: React.FC<PlayerListProps> = ({ players, seriesName }) => {
    const theme = localStorage.getItem("theme");
    const router = useRouter();

    const getBattingStyleAbbreviation = (text: string): string => {
        if (!text) return "";
        // Split by hyphen or whitespace
        const words = text?.split(/[-\s]+/);
        return words?.map((word) => word?.charAt(0).toUpperCase()).join("");
    };

    return (
        <div className={styles["playerListContainer"]} data-theme={theme}>
            {players?.map((player) => {
                const SkillIcon = player?.player_skill
                    ? skillSvgMapping[player?.player_skill]
                    : () => {};
                const playerSkillsShortName =
                    skillStringMapping[player?.player_skill];
                const uniqueKey = player.player_id
                    ? `player-${player.player_id}`
                    : `player-${player.id}`;
                return (
                    <React.Fragment key={uniqueKey}>
                        {player?.player_name && (
                            <div
                                className={styles["playerRow"]}
                                key={player.id}
                                data-theme
                            >
                                <div className={styles["playerInfo"]}>
                                    <div
                                        className={styles["playerName"]}
                                        data-theme={theme}
                                    >
                                        <div
                                            style={{
                                                borderBottom:
                                                    "1px solid #D1D5DB",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                router.push(
                                                    `/wiki/sports/cricket/players/${encodeToBase64(
                                                        `{"player_id":"${player.player_id}"}`,
                                                    )}`,
                                                );
                                            }}
                                        >
                                            {player.player_name}
                                        </div>
                                        {player.player_is_captain && (
                                            <span
                                                className={styles["captainTag"]}
                                            >
                                                (C)
                                            </span>
                                        )}
                                        {INTERNATIONAL_LEAGUE_MATCHES.includes(
                                            seriesName,
                                        ) &&
                                            !player?.is_indian &&
                                            player.player_nationality !==
                                                "" && <ForeignPlayer />}
                                    </div>
                                    <div className={styles["batStyle"]}>
                                        {player?.batting_style_text &&
                                            getBattingStyleAbbreviation(
                                                player?.batting_style_text,
                                            )}
                                        {player?.batting_style_text &&
                                            player?.bowling_style_text && (
                                                <>&nbsp;,&nbsp;</>
                                            )}
                                        {player?.bowling_style_text &&
                                            getBattingStyleAbbreviation(
                                                player?.bowling_style_text,
                                            )}
                                    </div>
                                </div>
                                <div className={styles["countryInfo"]}>
                                    {/* <img
                           src={player.team_flag}
                           alt='team-flag'
                           className={styles['flagIcon']}
                       /> */}
                                    <span
                                        className={styles["countryCode"]}
                                        data-theme={theme}
                                    >
                                        {[
                                            "Domestic-Firstclass",
                                            "Domestic-Lista",
                                            "100 ball",
                                            "in_tten",
                                            "Domestic-T20",
                                        ].includes(seriesName) &&
                                            player?.player_nationality}
                                    </span>
                                </div>
                                <div
                                    className={styles["player-info-desktop"]}
                                    data-theme={theme}
                                >
                                    {SkillIcon && (
                                        <SkillIcon
                                            className={styles["skillIcon"]}
                                            data-theme={theme || "light"}
                                        />
                                    )}
                                    {playerSkillsShortName}
                                </div>{" "}
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default PlayerList;
